(function initializeBannerCarousel() {
  if (customElements.get('banner-carousel')) return;

  class BannerCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-banner-viewport]');
      this.previousButton = this.querySelector('[data-banner-previous]');
      this.nextButton = this.querySelector('[data-banner-next]');

      if (!this.viewport || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', this.previous);
      this.nextButton.addEventListener('click', this.next);
      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this.viewport);
      this.updateControls();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.previous);
      this.nextButton?.removeEventListener('click', this.next);
      this.resizeObserver?.disconnect();
    }

    previous = () => this.scroll(-1);

    next = () => this.scroll(1);

    scroll(direction) {
      const slide = this.viewport.querySelector('.banner-carousel__slide');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this.viewport.firstElementChild).columnGap) || 0;
      const rtlDirection = document.documentElement.dir === 'rtl' ? -1 : 1;

      this.viewport.scrollBy({
        left: direction * rtlDirection * (slide.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    updateControls = () => {
      const hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 1;
      this.previousButton.hidden = !hasOverflow;
      this.nextButton.hidden = !hasOverflow;
    };
  }

  customElements.define('banner-carousel', BannerCarousel);
})();
